import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import styles from './index.module.scss';
import Header from '@/tpss/pages/comps/Header';

const TPSSLaoyout: React.FC = () => {
  const location = useLocation();
  const { pathname } = location;
  const isHomePage = pathname === '/mocklogin' || pathname === '/product';

  return (
    <div className={styles.layout}>
      {!isHomePage && <Header />}
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
};

export default TPSSLaoyout;
